import { Alert, Snackbar } from "@mui/material";

import { ClockIcon } from "@phosphor-icons/react";

import { useLessonTimer } from "@/hooks/useLessonTimer";
import { Lesson } from "@/types";

interface Props {
  lessonInfo: Lesson | null;
  isSandbox?: boolean;
}

const TimerSnackbar = ({ lessonInfo, isSandbox = false }: Props) => {
  const { remainingMinutes } = useLessonTimer(lessonInfo, isSandbox);

  if (
    (!isSandbox && (!lessonInfo || !lessonInfo.hasStarted)) ||
    lessonInfo?.hasCompleted ||
    remainingMinutes >= 5
  ) {
    return null;
  }

  return (
    <Snackbar
      open={true}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      sx={{
        zIndex: 1000,
        pointerEvents: "none", // Allow clicking through to elements behind if needed, but the Alert itself should probably have pointerEvents: "auto"
        "& .MuiAlert-root": {
          pointerEvents: "auto"
        }
      }}
    >
      <Alert
        icon={<ClockIcon weight="bold" />}
        severity="info"
        variant="standard"
      >
        Time remaining: {remainingMinutes} min
      </Alert>
    </Snackbar>
  );
};

export default TimerSnackbar;
